/**
 * Phase 13 — Client-side invoker for the always-on OCR + Vision pipeline.
 * Fire-and-forget. Failures are logged but never thrown to the upload UI.
 */

import { supabase } from '@/integrations/supabase/client';

export interface RunPipelineArgs {
  shopId: string;
  ticketId: string;
  mediaId: string;
  vehicle?: { year?: number; make?: string; model?: string };
  force?: boolean;
}

export async function runOcrAndVisionPipeline(args: RunPipelineArgs): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke('dvi-ocr-vision-pipeline', {
      body: {
        shop_id: args.shopId,
        ticket_id: args.ticketId,
        media_id: args.mediaId,
        vehicle: args.vehicle,
        force: args.force ?? false,
      },
    });
    if (error) {
      console.warn('[runOcrAndVisionPipeline] invoke error:', error);
    }
  } catch (err) {
    console.warn('[runOcrAndVisionPipeline] unexpected error:', err);
  }
}

/** Run pipeline for a batch of media in parallel (fire-and-forget). */
export function runOcrAndVisionPipelineBatch(
  base: Omit<RunPipelineArgs, 'mediaId'>,
  mediaIds: string[],
): void {
  for (const mediaId of mediaIds) {
    void runOcrAndVisionPipeline({ ...base, mediaId });
  }
}
